import React from 'react';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfirmationToastProps } from '@helpers/Models';
import { faCircleCheck, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export const ConfirmationToast: React.FC<ConfirmationToastProps> = ({
  title,
  message,
  onClose,
  onAction,
  buttonName,
  type, // For displaying success, info and delete confirmations with their respective styles
  onCancel,
  cancelButtonName,
}) => (
  <div
    className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
    ${type === 'success' ? 'w-[28rem]' : 'w-96'} 
    bg-white border rounded-lg shadow-lg z-20`}
    role="alert"
    aria-live="assertive"
  >
    {/* <div
      className={`fixed top-4 right-4 ${type === 'success' ? 'w-[21rem]' : 'w-72'} bg-white border rounded-lg shadow-lg z-20`}
      role="alert"
      aria-live="assertive"
    > */}
    {/* Header */}
    <div
      className={`flex items-center justify-between px-4 py-2 ${type === 'success' ? 'bg-[#28B24C33]' : ''}
      rounded-t-lg`}
    >
      <div className="flex items-center gap-2">
        {type === 'delete' ? (
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-100">
            <FontAwesomeIcon icon={faTrashCan} className="text-red-500" />
          </div>
        ) : type === 'success' ? (
          <FontAwesomeIcon icon={faCircleCheck} className="text-[#28B24C]" />
        ) : type === 'info' ? (
          <FontAwesomeIcon icon={faCircleInfo} className="text-[#376BFC]" />
        ) : null}

        <h2 className="font-semibold text-sm">{title}</h2>
      </div>

      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="text-gray-600 hover:text-gray-700 focus:outline-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
    {/* Body */}
    <div className="px-4 py-3 text-[#000A16]">
      <p className="text-sm">{message}</p>
      {/* For invoice generation success */}
      {type === 'success' && (
        <p className="mt-6 text-sm">
          You can view this invoice on the All Invoices page.
        </p>
      )}
    </div>
    {/* Action Buttons */}
    <div className="flex justify-end px-4 py-3 rounded-b-lg">
      {cancelButtonName && onCancel && (
        <button
          type="button"
          onClick={() => {
            onCancel?.(); // run cancel logic if provided
            onClose?.(); // close toast
          }}
          className="ml-2 text-primary text-sm font-semibold px-4 py-2 rounded-md hover:bg-gray-200 transition"
        >
          {cancelButtonName ?? 'Cancel'}
        </button>
      )}

      <button
        type="button"
        onClick={onAction}
        className={` ${type === 'delete' ? 'text-red-500 border-red-500' : 'text-white bg-primary'} text-sm font-semibold px-4 py-2 rounded-md transition border `}
      >
        {/* {type === 'info' ? 'Confirm Payment' : type === 'success' ? 'View all invoices' : 'Remove All'} */}
        {buttonName ?? 'Remove All'}
      </button>
    </div>
  </div>
);
